(() => {
	// Apply column CSS to Choice Elements  
	$(document).ready(() => {
		const applyColumns = (e) => {
			const intViewportWidth = window.innerWidth;
			if (intViewportWidth > 768) {
				$('fieldset').each((i, elm) => {
					$(elm).css({ "display": "grid", "grid-auto-flow": "column" });

					let devider = 1;
					let lstInputs = $(elm).find('label.jsNeoInput');
					if (lstInputs.length > 5 && lstInputs.length < 11) {
						devider = 2;
					} else if (lstInputs.length > 10) {
						devider = 3;
					}
					let noOfRows = parseInt(lstInputs.length / devider);
					$(elm).css("grid-template-rows", "repeat(" + noOfRows + ", auto)");
				});
			} else {
				$('fieldset').each((i, elm) => {
					$(elm).css({ "display": "", "grid-auto-flow": "", "grid-template-rows": "" });
				});
			}
		}

		applyColumns();

		window.addEventListener("resize", () => {
			applyColumns();
		});
	})
})();